// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';

import { OrganizationService, RolesService } from '@app/core';
import {
  RoleDetailsActionTypes,
  LoadingRoleDetailsAction,
  CompleteLoadRoleDetailsAction,
  FailLoadRoleDetailsAction,
  OrgLoadingRoleDetailsAction,
  OrgCompleteLoadRoleDetailsAction,
  OrgFailLoadRoleDetailsAction
} from './role-details.actions';

@Injectable()
export class RoleDetailsEffects {
  @Effect()
  requestOnLoadRoles$ = this.actions$.pipe(
    ofType<LoadingRoleDetailsAction>(RoleDetailsActionTypes.ROLE_DETAILS_LOADING),
    flatMap(action => this.requestRole(action.payload))
  );

  @Effect()
  requestOrgOnLoadRoles$ = this.actions$.pipe(
    ofType<OrgLoadingRoleDetailsAction>(RoleDetailsActionTypes.ORG_ROLE_DETAILS_LOADING),
    flatMap(action => this.requestOrgRoles(action.payload.orgId, action.payload.roleId))
  );

  constructor(private actions$: Actions, private rolesService: RolesService, private orgService: OrganizationService) {}

  private requestRole(roleId: string): Observable<CompleteLoadRoleDetailsAction | FailLoadRoleDetailsAction> {
    return this.rolesService.get(roleId).pipe(
      map(roles => new CompleteLoadRoleDetailsAction(roles)),
      catchError(_ => of(new FailLoadRoleDetailsAction(roleId)))
    );
  }

  private requestOrgRoles(
    orgId: string,
    roleId: string
  ): Observable<OrgCompleteLoadRoleDetailsAction | OrgFailLoadRoleDetailsAction> {
    return this.orgService.getOrgRoles(orgId, roleId).pipe(
      map(roles => new OrgCompleteLoadRoleDetailsAction(roles)),
      catchError(_ => of(new OrgFailLoadRoleDetailsAction({ orgId, roleId })))
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-details.effects.ts